import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import approve from 'approvejs'

import Widget from '../../../components/widget'
import Select from '../../../components/select'
import InputText from '../../../components/input-text'
import InputMask from '../../../components/input-mask'

import api from '../../../actions/api'
import { toastError, toastSuccess } from '../../../actions/toast'
import { handleError } from '../../../actions/handle-error'

class Index extends Component {

  constructor() {
    super();

    this.submit = this.submit.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.validate = this.validate.bind(this)
    this.validateField = this.validateField.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      errors: [],
      id: '',
      phone_type: '',
      number: '',
      person_id: '',
      person_name: '',
      extension: '',
      fields: [
        {
          value: '',
          name: 'phone_type',
          options: [
            { label: 'Trabalho', value: 'TRABALHO' },
            { label: 'Casa', value: 'CASA' },
            { label: 'Celular', value: 'CELULAR' },
            { label: 'Outro', value: 'OUTRO' },
          ],
          type: 'text',
          errors: [],
          rules: {}
        },
        {
          value: '',
          name: 'number',
          type: 'text',
          errors: [],
          rules: {
            required: {
              message: 'Campo número é obrigatório'
            },
          }
        },
        {
          value: '',
          name: 'extension',
          type: 'text',
          errors: [],
          rules: {}
        },
      ],
      valid: false,
    }
  }

  componentDidMount() {
    const { personId, id } = this.props.match.params;
    this.setState({
      person_id: personId,
      phone_type: 'CASA',
      id: id
    })

    if (personId) this.getPerson(personId);
    if (id) this.getPhone(id);
  }

  validateField(e, field, fields) {
    e.preventDefault()
    field.value = ''
    let result = approve.value(e.target.value, field.rules)
    field.errors = []
    if (result.errors.length > 0) {
      field.errors = Array.from(result.errors)
      field.value = ''
    } else {
      field.value = e.target.value
    }
    fields = fields.map(item => {
      if (item.name === field.name) {
        return field
      } else {
        return item
      }
    })
    return fields
  }

  validate(e, field) {
    let fields = this.validateField(e, field, this.state.fields)
    let errors = [];
    let valid = false;

    fields.map(field => {
      let result = approve.value(field.value, field.rules)

      if (result.errors.length > 0) {
        errors.push(field.name);
      }

      return errors;
    })

    if (errors.length > 0) {
      valid = false
    } else {
      valid = true
    }

    this.setState({
      fields: fields,
      errors: errors,
      valid: valid
    })
    return false
  }

  submitForm = (e, fields) => {
    e.preventDefault()
    fields = fields.map(field => {
      field.errors = []
      let result = approve.value(field.value, field.rules)

      if (result.errors.length > 0) {
        field.errors = Array.from(result.errors)
      }
      return field
    })
    return fields
  }

  submit(e) {
    e.preventDefault()
    const { valid, errors, id } = this.state;

    let fields = this.submitForm(e, this.state.fields);
    this.setState({ fields: fields });

    if (valid && errors.length === 0) {
      id ? this.update() : this.save();
    }
    return false
  }


  getPerson = async id => {
    await api.get(`people/${id}`)
      .then(result => {
        const person = result.data;

        this.setState({
          person_id: person.id,
          person_name: person.name
        });

        this.props.dispatch({
          type: 'SET_BREADCRUMB',
          items: [
            { page: 'Home', url: '/' },
            { page: 'Pessoas', url: '/people' },
            { page: `${person.name}`, url: `people/${person.id}` },
            { page: 'Telefones', url: '#' },
          ]
        })
      }).catch(error => {
        if (error.response.status === 500) this.props.history.push('/people')
        toastError(handleError(error))
      });
  }

  getPhone = async id => {
    await api.get(`phones/${id}`)
      .then(result => {
        const phone = result.data;
        const fields = this.state.fields;

        fields[0].value = phone.phone_type;
        fields[1].value = phone.number;
        fields[2].value = phone.extension;

        this.setState({
          id: phone.id,
          person_id: phone.person_id,
          phone_type: phone.phone_type || '',
          number: phone.number || '',
          extension: phone.extension || '',
        })

        this.getPerson(phone.person_id);
      }).catch(error => {
        if (error.response.status && error.response.status === 500) this.props.history.push('/people')
        toastError(handleError(error))
      });
  }

  save = async () => {
    const phone = this.state;

    await api.post(`people/${phone.person_id}/phones`, phone)
      .then(result => {
        toastSuccess('Novo telefone incluído!');

        this.props.history.push(`/people/${phone.person_id}`)
      }).catch(error => {
        toastError(handleError(error));
      })
  }

  update = async () => {
    const phone = this.state;

    await api.put(`phones/${phone.id}`, phone).then(() => {
      toastSuccess(`Telefone de ${phone.person_name} atualizado!`);
    }).catch(error => {
      toastError(handleError(error));
    })
  }

  handleChange(event) {
    const name = event.target.name;
    const phone = this.state;
    const fields = this.state.fields;

    fields[0].value = phone.phone_type;
    fields[1].value = phone.number;
    fields[2].value = phone.extension;

    this.setState({
      [name]: event.target.value,
      fields: fields
    })
  }

  render() {
    const phone = this.state;

    return (
      <Widget
        title={phone.id ? 'Editar Telefone' : 'Novo Telefone'}
        description="">
        <div className="row">
          <div className="col">
            <form onSubmit={this.submit}>
              <div className="col col-md-4">
                <Select
                  label="* Tipo"
                  value={phone.phone_type}
                  options={phone.fields[0].options}
                  onChange={this.handleChange}
                  field={phone.fields[0]}
                  validate={(e, field) =>
                    this.validate(e, phone.fields[0])}
                />
              </div>

              <div className="row p-2">
                <div className="col-sm col-md-4">
                  <InputMask
                    label="* Número"
                    value={phone.number}
                    mask={phone.phone_type === 'CELULAR' ? '(99) 99999-9999' : '(99) 9999-9999'}
                    onChange={this.handleChange}
                    field={phone.fields[1]}
                    validate={(e, field) =>
                      this.validate(e, phone.fields[1])}
                  />
                </div>

                {phone.phone_type !== 'CELULAR' &&
                  <div className="col-sm col-md-4">
                    <InputText
                      label="Ramal"
                      value={phone.extension}
                      onChange={this.handleChange}
                      field={phone.fields[2]}
                      validate={(e, field) =>
                        this.validate(e, phone.fields[2])}
                    />
                  </div>
                }
              </div>

              <div className="row col-8 p-0 m-0 justify-content-end mb-3 ">
                <div className="col col-md-4 mt-3">
                  <Link to="#">
                    <button
                      className="btn btn-success btn-block"
                      disabled={!phone.valid}
                      onClick={this.submit}>
                      {phone.id ? 'Atualizar' : 'Salvar'}
                    </button>
                  </Link>
                </div>

                <div className="col col-md-3 mt-3">
                  <Link to={`/people/${phone.person_id}`}>
                    <button
                      className="btn btn-success btn-block ">
                      Voltar
									</button>
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Widget >
    )
  }
}

export default Index;